<template>
<!--	精彩回顾详情页-->
  <div class="hr_detail">
  	<div class="m">
  		<!--面包屑-->
  		<div class="breabcrumb_box">
	  		<el-breadcrumb separator-class="el-icon-arrow-right">
				  <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
				  <el-breadcrumb-item :to="{ path: '/eight_min_highlight_replays' }">精彩回顾</el-breadcrumb-item>
				  <el-breadcrumb-item>案例详情</el-breadcrumb-item>
				</el-breadcrumb>
  		</div>

  		<div class="unite">

	  		<div class="content_box">
	  			<h3 v-html="reviewParam.title"></h3>
	  			<div class="time_box">
					<p>
						<i class="el-icon-time"></i>
						<span class="year">{{reviewParam.activity_date}}</span>
					</p>
					<router-link :to="{path:'/eight_min_dcim',query:{id:reviewParam.id}}">直播云相册<i class="el-icon-arrow-right"></i></router-link>
				</div>
				<!--<p class="synopsis" v-html="reviewParam.synopsis || '暂无简介'"></p>-->
				<p class="content" v-html="reviewParam.content || '暂无内容'"></p>
	  		</div>

	  		<div class="review_box">
	  			<h3>相关回顾</h3>
				<ul>
					<el-scrollbar class="page-component__scroll">
						<li v-for="(item,index) in list" :key="index" @click="getDetail(item.id,item.class_one)">
							<div class="list_img">
								<img :src="item.coverPath" alt="">
							</div>
							<p>{{item.title.length>16?item.title.slice(0,16) + '...':item.title}}</p>
							<span>{{item.popularity || 0}}人气值</span>
						</li>
					</el-scrollbar>
	  			</ul>
	  		</div>
  		</div>

  	</div>
  </div>
</template>

<script>
  export default {
	created(){
		this.getData()
		this.getAllData()
	},
    watch:{
	    $route(){
	  	  this.getData();
	    }
    },
	data(){
		return{
			reviewParam:{},
			list:[],
		}
	},
	methods:{
		getData() {
			let params = {
				id:this.$route.query.id
			};
			this.api.getEightActivities(params).then(res => {
				if (res.error["err_code"] !== 0) return;
				this.reviewParam = res.obj.list[0];
			});
		},

		//相关回顾
		getAllData() {
			let params = {
				type:'EightMinActivityTypeReview',
				class_one: this.$route.query.name,
				active: true,
			};
			this.api.getEightActivities(params).then(res => {
				if (res.error["err_code"] !== 0) return;
				console.log(res);
				this.list = res.obj.list;
			});
		},

		//全部回顾跳转
		getDetail(id,class_one){
			this.$router.push({path:'/eight_min_hr_detail',query:{id:id,name:class_one}})
		}
	}
  }
</script>

<style lang="scss">
.hr_detail{
	background-color: #F0F2F5;
	.m{
		.breabcrumb_box{
			padding: 20px 0;
			.el-breadcrumb__inner.is-link, .el-breadcrumb__inner a {
	    	font-size: 12px;
	    	color: #4B5062FF;
			}
			.el-breadcrumb__item:last-child .el-breadcrumb__inner{
				font-size: 12px;
				color: #4c84ff;
			}
		}
		.unite{
			display: flex;
			.content_box{
				width:880px;
				border-radius:2px;
				padding: 30px 20px 50px;
				margin-bottom: 20px;
				margin-right: 20px;
				box-sizing: border-box;
				overflow: hidden;
				background-color: #fff;
				h3{
					font-size:28px;
					line-height: 44px;
					font-weight: bold;
					color:#4B5062;
					margin-bottom: 20px;
				}
				.time_box{
					border-bottom: 2px solid rgba(238,239,242,1);
					padding-bottom: 20px;
					margin-bottom: 30px;
					display: flex;
					justify-content: space-between;
					p{
						margin-bottom: 0px;
					}
					.el-icon-time{
						font-size: 14px;
					}
					.year{
						display: inline-block;
						font-size: 14px;
						color: #9FA4B1FF;
						margin-left: 8px;
					}
					a{
						font-size: 14px;
					}
				}
				.synopsis{
					font-size:14px;
					color:#4B5062FF;
					line-height: 24px;
					margin-bottom: 20px;
					text-align: justify;
				}
				a{
					display: inline-block;
					float: right;
					color: #4c84ff;
				}
			}
			.review_box{
				width:300px;
				height:540px;
				border-radius:2px;
				background-color: #fff;
				h3{
					padding: 12px 20px 16px;
					border-bottom: 2px solid #EEEFF2FF;
					font-size: 16px;
					line-height: 18px;
					font-weight: 400;
					color: #4B5062FF;
				}
				ul{
					padding: 20px 10px 0 16px;
					height:470px;
					overflow: hidden;
					.page-component__scroll{
						height: 100%;
						overflow: hidden;
						.el-scrollbar__wrap{
							overflow: auto;
							overflow-x: hidden;
							.el-scrollbar__thumb{
								height: 61%;
							}
						}
					}
					li{
						margin-bottom: 15px;
						cursor: pointer;
						overflow: hidden;
						.list_img{
							width: 130px;
							height: 74px;
							float: left;
							overflow: hidden;
							img{
								width: 100%;
								height: 100%;
								transition: all 0.2s;
							}
						}
						p{
							padding: 5px 0 0 10px;
							width: 130px;
							font-size:14px;
							line-height: 18px;
							color:#4B5062FF;
							float: left;
						}
						span{
							display: block;
							float: left;
							padding: 10px;
							font-size:12px;
							color:#9FA4B1FF;
							line-height: 14px;
						}
					}
					li:hover{
						p {
							color: #4c84ff;
						}
						span{
							color:#4c84ff;
						}
						img{
							transform: scale(1.1,1.1);
						}
					}
				}
			}
		}
	}
}
</style>
